import axios from 'axios'

const surveyApiService = {
  // Submitted ratings, with the Lot and the user each rating came from
  getSurveys: ({ page = 1, limit = 25, status = 'completed' } = {}) => {
    return axios.get('/surveys/admin', { params: { page, limit, status } })
      .then(res => ({
        surveys: res.data.surveys || [],
        totalCount: res.data.totalCount || 0
      }))
      .catch(() => ({ surveys: [], totalCount: 0 }))
  },

  // Submitted ratings grouped by auction; pagination is over auctions
  getSurveysByAuction: ({ page = 1, limit = 25, status = 'completed' } = {}) => {
    return axios.get('/surveys/admin/by-auction', { params: { page, limit, status } })
      .then(res => ({
        auctions: res.data.auctions || [],
        totalCount: res.data.totalCount || 0
      }))
      .catch(() => ({ auctions: [], totalCount: 0 }))
  }
}

export default surveyApiService
